import { render, staticRenderFns } from "./AppButtonSubmit.vue?vue&type=template&id=70a0eb05&scoped=true&"
import script from "./AppButtonSubmit.vue?vue&type=script&lang=js&"
export * from "./AppButtonSubmit.vue?vue&type=script&lang=js&"
import style0 from "./AppButtonSubmit.vue?vue&type=style&index=0&id=70a0eb05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a0eb05",
  null
  
)

export default component.exports